import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
	removeTeamConversation,
	toggleCurrentConversationMute,
	toggleCurrentConversationStarred,
} from '../../../actions/teams';
import {
	DropdownMenu,
	DropdownMenuItem,
	DropdownMenuTrigger,
	DropdownMenuContent,
} from '@/components/ui/dropdown-menu';
import { IconButton } from '@/components/ui/custom/IconButton';
import {
	Ellipsis,
	LogOut,
	Star,
	StarOff,
	Volume2,
	VolumeX,
} from 'lucide-react';

const ConversationMenu = ({
	conversation,
	isDirectMessage,
	doesCurrentUserHaveConversationMuted,
	doesCurrentUserHaveConversationStarred,
}) => {
	const [menuOpen, setMenuOpen] = useState(false);
	const [isConversationStarred, setIsConversationStarred] = useState(
		doesCurrentUserHaveConversationStarred
	);

	const dispatch = useDispatch();

	// eslint-disable-next-line no-unused-vars
	const [isConversationMuted, setIsConversationMuted] = useState(
		doesCurrentUserHaveConversationMuted
	);

	const handleLeaveConversation = () => {
		dispatch(removeTeamConversation({ conversation }));
		setMenuOpen(false);
	};

	const handleMuteConversation = () => {
		dispatch(
			toggleCurrentConversationMute({
				_teamConversation: conversation._id,
				_business: conversation._business,
				isCurrentConversationMuted: !isConversationMuted, // Toggle the value here
			})
		);

		setIsConversationMuted(!isConversationMuted); // Update the state after dispatch

		setMenuOpen(false);
	};

	const handleStarConversation = () => {
		dispatch(
			toggleCurrentConversationStarred({
				_teamConversation: conversation._id,
				_business: conversation._business,
				isCurrentConversationStarred: !isConversationStarred,
			})
		);

		setIsConversationStarred(!isConversationStarred);
		setMenuOpen(false);
	};

	const handleClick = (event) => {
		event.stopPropagation();
		setMenuOpen(true);
	};

	return (
		<div>
			<DropdownMenu
				open={menuOpen}
				onOpenChange={() => {
					setMenuOpen(!menuOpen);
				}}
			>
				<DropdownMenuTrigger>
					<IconButton onClick={handleClick} className="h-6 w-6">
						<Ellipsis className="size-4 text-muted-foreground" />
					</IconButton>
				</DropdownMenuTrigger>
				<DropdownMenuContent>
					{/* channels follow the location and departments, so they can't be left */}
					{!isDirectMessage && !conversation.channel ? (
						<DropdownMenuItem onSelect={handleLeaveConversation}>
							<LogOut className="size-5 mr-2" />
							Leave Conversation
						</DropdownMenuItem>
					) : null}
					<DropdownMenuItem onSelect={handleMuteConversation}>
						{isConversationMuted ? (
							<>
								<Volume2 className="size-5 mr-2" />
								Unmute Conversation
							</>
						) : (
							<>
								<VolumeX className="size-5 mr-2" />
								Mute Conversation
							</>
						)}
					</DropdownMenuItem>
					<DropdownMenuItem onSelect={handleStarConversation}>
						{isConversationStarred ? (
							<>
								<StarOff className="size-5 mr-2" />
								Unstar Conversation
							</>
						) : (
							<>
								<Star className="size-5 mr-2" />
								Star Conversation
							</>
						)}
					</DropdownMenuItem>
				</DropdownMenuContent>
			</DropdownMenu>
		</div>
	);
};

export default ConversationMenu;
